/**
 * @file ExperienceForm.style.js
 * Exports ExperienceForm component styles.
 */

export default theme => ({
  textField: {
    width: '100%',
    marginTop: `${theme.spacing.unit * 2}px`
  },
  button: {
    marginTop: `${theme.spacing.unit * 3}px`,
    marginRight: theme.spacing.unit
  }
});



// WEBPACK FOOTER //
// ./src/components/ExperienceForm/ExperienceForm.style.js